import { getTranslatedCabin } from 'obt-common';
import { translate } from 'src/translations';

export const UNKNOWN_CABIN_BRAND_NAME = 'Unknown Cabin';
const getBrandText = ({ isMixedCabin, brandName }: { isMixedCabin: boolean; brandName: string }): string => {
  let brand = '';
  if (isMixedCabin) {
    brand = translate('Mixed cabin');
  } else if (brandName !== UNKNOWN_CABIN_BRAND_NAME) {
    brand = brandName;
  }

  return brand;
};

interface IArgs {
  brandName: string;
  cabin: string;
  bookingCode: string;
  isMixedCabin: boolean;
}
const getBrandCabinBookingCodeText = ({ brandName, cabin, bookingCode, isMixedCabin }: IArgs): string => {
  const translatedCabin = getTranslatedCabin(cabin);
  const cabinAndBookingCode = [translatedCabin, bookingCode || ''].filter(Boolean).join(',');
  const brand = getBrandText({ isMixedCabin, brandName });

  return [brand, cabinAndBookingCode ? `(${cabinAndBookingCode})` : undefined].filter(Boolean).join(' ');
};

export default getBrandCabinBookingCodeText;
